import { useCallback, useMemo, useState } from "react";
import { Clause } from "@radarly/models/clause";
import { areClausesEqual, isClauseEmpty } from "@radarly/models/clause/is";
import { refineClauseWithoutField } from "@radarly/models/clause/refiner";

export function useDraftClause(
  clause: Clause,
  setClause: (clause: Clause) => void
) {
  const [draft, setDraft] = useState<Clause>(null);
  const [hasDraft, setHasDraft] = useState(false);

  const onSubmitDraft = useCallback(() => {
    setDraft(null);
    setHasDraft(false);
    setClause(draft || clause);
  }, [clause, draft, setClause]);

  const onSubmit = useCallback(
    (_clause: Clause) => {
      setDraft(null);
      setHasDraft(false);
      setClause(_clause);
    },
    [setClause]
  );

  const onCancelDraft = () => {
    setDraft(null);
    setHasDraft(false);
  };

  const onClose = useCallback(() => {
    if (draft) {
      setHasDraft(!areClausesEqual(draft, clause));
    }
  }, [clause, draft]);

  const hasClause = useMemo(
    () => !isClauseEmpty(refineClauseWithoutField(clause, "date")),
    [clause]
  );

  return {
    setDraft,
    draft,
    hasDraft,
    onSubmitDraft,
    onSubmit,
    onCancelDraft,
    onClose,
    hasClause,
  };
}
